"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Builder to create validation error message map.
 */
var ValidationErrorMessageBuilder = /** @class */ (function () {
    function ValidationErrorMessageBuilder() {
        this.validatorMessageMap = {};
    }
    /**
     * Create a new builder.
     */
    ValidationErrorMessageBuilder.create = function () {
        return new ValidationErrorMessageBuilder();
    };
    /**
     * Map the validator name message towards an error message.
     * @param validatorName the name of the validator
     * @param message the error message
     */
    ValidationErrorMessageBuilder.prototype.map = function (validatorName, message) {
        this.validatorMessageMap[validatorName] = message;
        return this;
    };
    /**
     * Validators that coexists on same element can have a combined message,
     * i.e. if a element have the required and the personnummer validator
     * the required error message could be combined with
     * mapCombined('required','personnummer', 'You must enter a social security number!');
     * @param validatorName
     * @param dependantValidatorName
     * @param message
     */
    ValidationErrorMessageBuilder.prototype.mapCombined = function (validatorName, dependentValidatorName, message) {
        this.validatorMessageMap[validatorName + "." + dependentValidatorName] = message;
        return this;
    };
    /**
     * Build the translation map.
     * @return the created map.
     */
    ValidationErrorMessageBuilder.prototype.build = function () {
        return this.validatorMessageMap;
    };
    return ValidationErrorMessageBuilder;
}());
exports.ValidationErrorMessageBuilder = ValidationErrorMessageBuilder;
//# sourceMappingURL=ValidationErrorMessageBuilder.js.map